import { CYPRESS_TEST_FLAG, LANGUAGE_ORDER_PREFERNCE } from 'common/utils/constants'
import { getCookie } from './cookies'
import { countryCodeToCurrencyCode } from './currencyFromCountry'
import { getCountryCode } from './countryCode'
import { getInitialUrlParams } from './initialUrlParams'

const getInitialUserCurrencyCode = () => getCookie('currency')?.toUpperCase() || countryCodeToCurrencyCode(getCountryCode())
const getInitialPathParameters = () => getInitialUrlParams()
const getInitialLanguageCode = () => getInitialPathParameters()?.languageCode ?? 'en'
const getGoogleMapsApiKey = () => 'AIzaSyBxQ1C1a8ewDgHckb30A3duwiVud15_DRw'
const getHost = () => HOST // injected by webpack depending on environment
const getServicesHost = () => SERVICES_HOST
const getIsDev = () => IS_DEV
const supportedLanguages = [
  'da', 'de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'nl', 'no', 'pl', 'pt', 'ru', 'sv', 'th',
  'zh', 'ro', 'ms', 'cs', 'hu', 'el', 'fi', 'sk', 'hr'
]
const getSupportedLanguageCodes = () => {
  return supportedLanguages.sort((a, b) => {
    const aOrderScore = LANGUAGE_ORDER_PREFERNCE[a] || 0
    const bOrderScore = LANGUAGE_ORDER_PREFERNCE[b] || 0
    return aOrderScore < bOrderScore ? 1 : -1
  })
}
const getSupportedHelpPageLocaleLookup = () => {
  return {
    en: 'en',
    de: 'de',
    es: 'es',
    pt: 'pt-BR',
    it: 'it',
    fr: 'fr',
    ru: 'ru-RU',
    pl: 'pl',
    nl: 'nl',
    da: 'da',
    no: 'nb-NO',
    sv: 'sv-SE',
    ja: 'ja-JP',
    ko: 'ko'
  }
}

const isRunningCypressTest = () => !!window[CYPRESS_TEST_FLAG]

export {
  getInitialLanguageCode,
  getInitialPathParameters,
  getInitialUserCurrencyCode,
  getHost,
  getServicesHost,
  getGoogleMapsApiKey,
  getSupportedLanguageCodes,
  getSupportedHelpPageLocaleLookup,
  isRunningCypressTest,
  getIsDev,
}
